export const border: string = '1px solid rgb(235, 235, 235)';
